// vue
import Vue from "vue";
import { mapGetters } from "vuex";

// services
import { ObjectUtil, PartListBuilderService } from "@/services";

// components
import { IGridListRowItem } from "@/components/Elements/PartsListGrid/PartsListGrid";
import { default as PartListing } from "../PartListing.vue";

// types
import { IQuickOrdersContext } from "../../QuickOrders.types";

export default Vue.extend({
  name: "RemovePartsConfirmation",
  components: {
    PartListing,
  },
  props: {
    context: {
      type: Object,
      default: () => ObjectUtil.createInstance<IQuickOrdersContext>(),
    },
    items: {
      type: Array,
      default: () => [] as IGridListRowItem[],
    },
  },
  computed: {
    ...mapGetters(["getContentItem"]),
  },
  methods: {
    async removeSelectedItems() {
      this.$emit("on-parts-removing");

      const items = this.items as IGridListRowItem[];
      const context = this.context as IQuickOrdersContext;

      const rq = {
        accountId: context.accountId,
        userId: context.user.UserId,
        partListId: Number(context.partListId),
        userAudiences: context.userAudiences,
        itemIds: items.filter((x) => x.Selected).map((x) => x.Id),
      };

      const result = await PartListBuilderService.DeleteItems(rq);

      this.$emit("on-parts-removed", result);
    },

    cancel() {
      this.$emit("on-cancel");
    },
  },
});
